import { render, staticRenderFns } from "./EditAccountAdditionalDetailsBtn.vue?vue&type=template&id=7ff31cd9&"
import script from "./EditAccountAdditionalDetailsBtn.vue?vue&type=script&lang=js&"
export * from "./EditAccountAdditionalDetailsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports